<template>
  <div>
    <h3 class="modal-title"> DYNAMIC WORKFLOW APPROVER </h3>
    <b-form-group :class="{'error-input' : $v.data_approver.title.$error}">
      <label> Dynamic Workflow Approver Title </label>
      <j-input
        v-model="$v.data_approver.title.$model"
        :max-length="255"
        placeholder="Workflow Approver Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_approver.workflow.$error}">
      <label> Select Workflow </label>
      <j-single-select
        v-model="$v.data_approver.workflow.$model"
        :options="workflowList"
        label="name"
        value-format="object"
        placeholder="Choose Workflow"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_approver.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_approver.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Choose Form'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeApprover">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveApprover">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_approver: {
      title: {
        required,
      },
      workflow: {
        required,
      },
      form: {
        required,
      },
    },
  },
  data() {
    return {
      data_approver: {
        title: '',
        workflow: null,
        form: null,
      },
      workflowList: [],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['workflow_list', 'workflow_detail']),

    generateDataApprover() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_approver.form.id,
        }),
        value_id: `${this.data_approver.workflow.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_approver.title,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },

    generateDataApproverUpdate() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_approver.form.id,
        }),
        value_id: `${this.data_approver.workflow.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_approver.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  watch: {
    workflow_list(data) {
      this.workflowList = data;
    },
  },
  async mounted() {
    this.actionGetDynamicWorkflow();

    if (this.modeEdit) {
      const formDetail = await this.getDetailForm({
        additional_info_block: {
          id: Number(JSON.parse(this.dataEdit.info).form_id),
        },
      });
      this.data_approver.form = {
        id: formDetail.id,
        name: formDetail.name,
        label: formDetail.name,
      };

      await this.actionFindDynamicWorkflow(Number(this.dataEdit.value_id));
      this.data_approver.workflow = {
        id: this.workflow_detail.id,
        name: this.workflow_detail.name,
        label: this.workflow_detail.name,
      };

      this.data_approver.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm', 'actionGetDynamicWorkflow', 'actionFindDynamicWorkflow']),

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveApprover() {
      this.$v.data_approver.$touch();
      if (!this.$v.data_approver.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataApprover,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataApproverUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeApprover();
      }
    },

    closeApprover() {
      this.$emit('close-field');
      this.data_approver.title = '';
      this.data_approver.workflow = null;
      this.data_approver.form = null;
      setTimeout(() => {
        this.$v.data_approver.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jBaktiWorkflowAppSetup.vue